module.exports = __webpack_public_path__ + "img/big-certificate-3.7c4bf30e.png";